import { Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ProductInfoAttributes } from '../../../model/product-info-attributes';
import { ProductService } from '../../../../pages/product/product.service';
import { HttpParams } from '@angular/common/http';
import { ProductAppwiz } from '../../../model/product-appwiz';
import { ToastService } from '../../../../@theme/service/toast.service';

@Component({
  selector: 'ngx-product-identification-column',
  template: `
    <nb-select
      fullWidth
      size="tiny"
      (selectedChange)="onSelectionChange($event)"
      [(selected)]="selectedProduct">
      <nb-option *ngFor="let product of listData" [value]="product">
        {{ product.productName }} - ({{ (product.confidence * 100) | number : '1.2-2' }}%)
      </nb-option>
    </nb-select>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class ProductIdentificationComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public data: any;
  public selectedProduct: any;
  public listData: any = [];

  constructor(
    private productService: ProductService,
    private toast: ToastService,
  ) {}

  agInit(params: ICellRendererParams): void {
    this.initData(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.initData(params);
    return true;
  }

  initData(params: ICellRendererParams) {
    this.params = params;
    this.data = this.params.data;
    if (this.data.multiResults && this.data.multiResults.length > 0) {
      this.listData = [...this.data.multiResults];
      const products = this.data.multiResults.filter(f => f.verdict);
      this.selectedProduct = products.length > 0 ? products[0] : null;
    }
  }

  onSelectionChange(event: any) {
    if (event) {
      this.selectedProduct = event;
      this.setCandidateResult(event.productCode);
    }
  }

  setCandidateResult(productCode: number) {
    this.findProductInfo(productCode).then(product => {
      const productInfo = new ProductInfoAttributes({
        productName: product.productName,
        publisherName: product.publisherName,
        iscanType: product.iscanType,
        swType: product.swType,
        licenseType: product.licenseType,
        swGroupCode: product.swGroup
      });
      this.params.data.productInfo = JSON.stringify(productInfo);
      this.params.data.attributes = JSON.stringify(this.params.data.attributeValues);
      this.params.data.reviewed = true;
      this.params.data.publisherCode = product.publisherCode;
      this.params.data.code = product.productCode;
      this.params.data.product = product.productName;
      this.params.data.publisher = product.publisherName;

      for (let res of this.params.data.multiResults) {
        if (res.productCode === productCode) {
          res.verdict = true;
        } else {
          res.verdict = false;
        }
      }

      this.params.api.refreshCells({ rowNodes: [this.params.node], columns: ['product', 'publisher', 'reviewed'] });
      this.params.context.addUpdatedNewItem(this.params.data);
    }).catch((err) => {
      console.error(err);
    });
  }

  findProductInfo(productCode: number): Promise<ProductAppwiz> {
    const params = new HttpParams().set('useFlag', 'true');
    return new Promise((resolve, reject) => {
      this.productService.findProductInfo(productCode, params).subscribe(res => {
        if (res && res.result) {
          resolve(res.data);
        } else {
          reject(null);
        }
      }, err => {
        this.toast.showToast('warning', '제품 정보를 찾을 수 없습니다.');
        reject(err);
      });
    });
  }
}
